export default "__VITE_ASSET__1c21e69f__"